import { FieldConfig } from "../../../SetupFormGenerator/types";
import {
  DecoratedMessageWithLinkDisplayType,
  DecoratedMessageWithLinkType,
} from "pages/employer-of-record/components/MessageWithLink/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";

export enum TaxableBenefits {
  CAR = "Car",
  CELL_PHONE_AND_INTERNET = "Cell Phone & Internet",
  COMMUTER_ALLOWANCE = "Commuter Allowance",
  EDUCATION = "Education",
  LIVING_ACCOMMODATIONS = "Living Accommodations",
  LOANS = "Loans",
  MEAL_ALLOWANCE = "Meal Allowance",
  MEDICAL_INSURANCE = "Medical Insurance",
  NON_CASH_GIFTS_AND_AWARDS = "Non-Cash Gifts & Awards",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational Facilities & Dues",
  REMOTE_WORK_ALLOWANCE = "Remote Work Allowance",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [TaxableBenefits.CELL_PHONE_AND_INTERNET]: {
    text: "Cell phone and internet reimbursements can be tax-free when provided as a fixed monthly amount. The recommended monthly reimbursement amount is PEN 150-220 per month.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.REMOTE_WORK_ALLOWANCE]: {
    text: "Mandatory remote work reimbursements can be tax-free when provided as a fixed monthly amount. The recommended monthly reimbursement amount is PEN 150-220 per month.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
} as const;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
